<template>
  <div class="">
    <Landing :landingData="landingData" />
    <AboutInstructor id="about" :instructorData="instructorData" />
    <ProgramInfo id="program" :info="programData" />
    <BasicRequirement :info="basicRequirement" />
    <PositionSummary :info="positionInfo" />
    <TestimonialCompany :info="companyTestimonial" style="padding-top:40px" />
    <Faq id="faq" :info="faq" />
    <Contact bgColor="#3A3A4C" />
  </div>
</template>
<script>
import AboutInstructor from '../../components/AssessmentIsa/AboutTheCompany.vue'
import TestimonialCompany from '../../components/AssessmentIsa/CompanyTestimonial.vue'
import Landing from '../../components/AssessmentIsa/LandingAssessment.vue'
import ProgramInfo from '../../components/AssessmentIsa/ProgramInfo.vue'
import Contact from '../../components/isaMain/Contact.vue'
import PositionSummary from '../../components/AssessmentIsa/PositionSummary.vue'
import BasicRequirement from '../../components/AssessmentIsa/BasicReq.vue'
import Faq from '../../components/shera/Faq.vue'

export default {
  data() {
    return {
      landingData: {
        title1: 'Work as a Financial Analyst at CMED  ',
        //   subTitle: 'Senior Marketing Executive (Contractual)',
        paragraph:
          'Apply for the assessment curated by Upskill and get a chance to work at CMED as a Financial Analyst.',
        companyLogo: '',
        quizLink:
          'https://quiz.upskill.com.bd/assessment/7e3bb9d5-70f8-4a8d-9d0f-69accd17602f?public=true&job=Cmed_Finance_Assessment',
        landingImage: require('../../assets/bongo/18775.png'),
        spanColor: 'grey',
      },
      instructorData: {
        //   name: 'Fayaz Taher',
        avatar: require('../../assets/cmed/cmed-logo.png'),
        info:
          'CMED Health Limited is a startup Health-tech company focusing on preventive healthcare. The mission at CMED is to accurately assess the vitals of people’s health, over time, in the environments where they live, work and play so they can live more productive lives. Through the innovative FDA approved smart health monitoring devices, technological support, and a passion to serve people, They provide easy to use, low cost regular health monitoring solutions to individuals and medical professionals.',
        designation: '',

        bgColor: '#DDEAFA',
        txtColor: '#29292B',
      },
      programData: {
        headingInfo:
          'The assessment consists of 15 MCQS. You are required to pass the assessment test with a minimum of 60% of the total score. Top 5-10 Candidates will get the chance to go to the interview round after completing the assessment.',
        startDate: 'March 2, 2022',
        cost: 'Free',
        deadline: 'March 9, 2022',
        quizLink:
          'https://quiz.upskill.com.bd/assessment/37a6c7d6-f21c-48e1-968e-74336c5109c3?public=true&job=isa_financial_analyst',
        bgColor: '#1EBCE5',
        txtColor: '#5277F7',
      },
      positionInfo: {
        //   paragraph:
        //     'This role is within the department Bongo Studios (www.bongostudios.com), which is the fastest-growing vertical within Bongo. Bongo Studios is a Multi-Channel Network (MCN) of a community of creative and independent content producers from multiple countries. We nurture talent and optimize content for our creators to help them achieve enhanced growth and monetization on multiple platforms (YouTube, Facebook, BongoBD, etc.). Currently, our creators reach over 180 million subscribers and have over 1.5 billion views per month.For this job role, we are looking for someone who is PMP certified and hassuccessfully managed a large team for at least 3 years, at a well-recognized company.The ideal candidate will be responsible for planning, coordinating, and managing the team within the timeline, budget, scope, and targets set for the department. They will also effectively monitor and present the updates to relevant stakeholders, clients, and team members.',
        //   remote: '',
        //   jobType: 'Job Type: Full-time ',
        //   txtColor: '#5277F7',
      },
      companyTestimonial: {
        //   mainImg: require('../assets/bongo/CTO_Bongo_Shadid 1.png'),
        //   name: 'Shadid Haque',
        //   paragraph:
        //     'At Bongo we believe in human-centric designs because people ignore design that ignores people. We are very excited to team up with Upskill in our mission to recruit the very best talents from all walks of life. We welcome anyone who wants to solve problems that impact millions of users and be part of a team that is empowered to do so.',
        //   designation: 'CTO  of Bongo',
        //   imgBg: '#DDEAFA',
        //   invertedCommaBg: '',
        //   firstComma: require('../assets/Canadian Tech company/“.svg'),
        //   secondComma: require('../assets/Canadian Tech company/Group 22.svg'),
      },
      basicRequirement: {
        mainContent: [
          'We are looking for skilled and experienced people to drive our organisation’s financial operations and improve financial performance.',

          'Duties for the finance Manager will include but not limited to supervising accounting staff, overseeing internal controls, setting financial targets, implementing fund-raising strategies, engaging with investors, developing a financial strategy, conducting feasibility studies, monitoring expenditure, overseeing annual insurance, monitoring cash flow, evaluating investments, and managing tax compliance.',

          'Maintenance and preparation of accounts as per requirements of local regulatory bodies and in compliance with international accounting standards.',

          'Oversee the financial strategic planning of the company by evaluating its performance and potential risks.',

          'Develop budgets that meet the requirements of company departments.',
          'Supervise all audit and internal control processes.',
          'Prepare detailed reports on the company’s financial performance.',
          'Guarantee compliance with financial laws and guidelines.',
          'Recognize patterns in company spending, revenue, and recommend solutions to any problem areas.',

          'Take ownership of business development activities of CMED.',

          ' Management of Company relationship with lenders, banks, investors, outside financial consultants (audit, tax, etc) and Government Offices including VAT, Income Tax.',

          'Identify opportunities for strategic improvements within the organization.',
          'Assist the senior management team in evaluating company capital projections and in fund raising initiatives by preparing presentations and investment; materials for potential investors and participating in meetings.',
          'Perform any other job as assigned by the management ',
        ],
        bgColor: '#184DBD',
      },

      outlineColor: {
        color: '#EA4424',
      },

      faq: [
        {
          title: 'What is the duration of the assessment? \n',
          content: '10 minutes. \n',
          category: 'FAQ',
        },
        {
          title: 'What is the assessment  fee? \n',
          content: 'It is free',
          category: 'FAQ',
        },
        {
          title: 'Do you need previous work experience? \n',
          content:
            'Yes, a minimum of 2+ years of experience in financial & managerial accounting.',
          category: 'FAQ',
        },
        {
          title: 'How much do I need to secure to qualify?\n',
          content: '60% of the total score i.e. 9 out of 15',
          category: 'FAQ',
        },

        {
          title: 'How many times can I take the quiz?\n',
          content:
            'You can take the quiz twice. The highest score will be counted as the final score.\n',
          category: 'FAQ',
        },
        {
          title: 'Will everyone get a chance to interview at CMED?\n',
          content:
            'No, the top 5 students will get a chance to interview at CMED, and will get the job depending on their performance in the interview.\n',
          category: 'FAQ',
        },
        {
          title: 'Salary?\n',
          content: ' BDT 40-60k \n',
          category: 'FAQ',
        },
      ],
    }
  },
  components: {
    Landing,
    AboutInstructor,
    Faq,
    ProgramInfo,
    Contact,
    TestimonialCompany,
    BasicRequirement,
    PositionSummary,
  },
  created() {
    this.Loaded()
  },
}
</script>
